$(document).ready(function(){
  
  // Initialize Testimonial Main Slider
  $('.testimonial-content-main').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991, // Tablets
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 576, // Mobile devices
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  // Initialize Single Image Carousel
  $('.single-image-carousel').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Initialize Product Testimonial Slider
  $('.product-testimonial-content-text-main').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991, // Tablets
        settings: {
          slidesToShow: 2,
          dots: false
        }
      },
      {
        breakpoint: 750, // Mobile devices
        settings: {
          slidesToShow: 1,
          dots: false
        }
      }
    ]
  });

  // Redirect for specific URL conditions
  if(window.location.href.includes('perfect-lipstick-free') || 
     window.location.href.includes('free-lipstick') || 
     window.location.href.includes('high-definition-mascara-free') || 
     window.location.href.includes('50-off-for-life')) {
    window.location.href = 'https://getlanera.com/products/lanera';
  }

  // Custom Video Block Play/Pause functionality
  $('.custom-video-block video, .custom-video-block .play_icon').click(function(){
    var video = $(this).closest('.custom-video-block').find('video')[0]; // Get the video inside the same block
    $(this).parents('.custom-video-block').toggleClass('active');
    if(video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  // Handle Variant Bundle Selection (Double/Triple Variant Logic)
  $('.product .new_variant_selection input, .sticky_product_form .new_variant_selection input').change(function() {
    var dataSelect = $(this).val();
    var forms = ['.product', '.sticky_product_form']; // Handle both forms

    forms.forEach(function(formSelector) {
      var $form = $(formSelector);

      var isLuxuryFoundationTemplate = document.body.classList.contains('template-luxury-foundation-funnelish') || document.body.classList.contains('template-luxury-foundation');
      if (dataSelect == 'double') {
        // Show double variant options and hide triple
        $form.find('input.product-variant-double').prop('disabled', false);
        if (isLuxuryFoundationTemplate) {
          $('.product-variant-double-selling').prop('disabled', false);
          var subCompare2 = $('#new_double_option + label .compaire_price').data('subcompareprice');
          var subPrice2 = $('#new_double_option + label .price .regular_price').data('subprice');  
          $('.custom_product_price .price-item.price-item--regular').text(subCompare2);
          $('.custom_product_price .price-item.price-item--sale.price-item--last').text(subPrice2);
        }
        $form.find('.two_variant_quantity').css('display', 'block');
        $form.find('input.product-variant-triple').prop('disabled', true);
        $form.find('.three_variant_quantity').css('display', 'none');
         
        if($('.subscription-toggle').is(':checked')){
          $('.product-variant-double-selling').prop('disabled', false);
            var subCompare2 = $('#new_double_option + label .compaire_price').data('subcompareprice');
            var subPrice2 = $('#new_double_option + label .price .price').data('subprice');  
            $('.custom_product_price .price-item.price-item--regular').text(subCompare2);
            $('.custom_product_price .price-item.price-item--sale.price-item--last').text(subPrice2);
        }
        else{
          if (isLuxuryFoundationTemplate) {
           $('.product-variant-double-selling').prop('disabled', false);
          }else{
            $('.product-variant-double-selling').prop('disabled', true);
          }
             var oneCompare2 = $('#new_double_option + label .compaire_price').data('onecompare');
             var onePrice2 = $('#new_double_option + label .price .price').data('oneprice');
              $('.custom_product_price .price-item.price-item--regular').text(oneCompare2);
             $('.custom_product_price .price-item.price-item--sale.price-item--last').text(onePrice2);
        }
        // Update UI
        updateVariantUI('two_select');
      } else if (dataSelect == 'triple') {
        // Show triple variant options 
        $form.find('input.product-variant-double').prop('disabled', false);
        $form.find('input.product-variant-triple').prop('disabled', false);
        $form.find('.two_variant_quantity').css('display', 'block');
        $form.find('.three_variant_quantity').css('display', 'block');
        // Update UI
        updateVariantUI('three_select');
      } 
      else {
        // Default state (single variant selection)
        $form.find('input.product-variant-double').prop('disabled', true);
        $form.find('input.product-variant-triple').prop('disabled', true);
        $form.find('.two_variant_quantity').css('display', 'none');
        $form.find('.three_variant_quantity').css('display', 'none');
          $('.product-variant-double-selling').prop('disabled', true);

      if (isLuxuryFoundationTemplate) {
          var subCompare = $('#new_single_option + label .compaire_price').data('subcompareprice');
          var subPrice = $('#new_single_option + label .price .regular_price').data('subprice');  
          $('.custom_product_price .price-item.price-item--regular').text(subCompare);
          $('.custom_product_price .price-item.price-item--sale.price-item--last').text(subPrice);
        }
        
        // Update UI
        
        updateVariantUI('one_select');
            if($('.subscription-toggle').is(':checked')){
                var subCompare1 = $('#new_single_option + label .compaire_price').data('subcompareprice');
                var subPrice1 = $('#new_single_option + label .price .price').data('subprice');
                 $('.custom_product_price .price-item.price-item--regular').text(subCompare1);
                 $('.custom_product_price .price-item.price-item--sale.price-item--last').text(subPrice1);
          }
          else{
                var oneCompare1 = $('#new_single_option + label .compaire_price').data('onecompare');
                var onePrice1 = $('#new_single_option + label .price .price').data('oneprice');
                $('.custom_product_price .price-item.price-item--regular').text(oneCompare1);
                $('.custom_product_price .price-item.price-item--sale.price-item--last').text(onePrice1);
          }
      }
    });
  });
$(document).ready(function() {
    // Trigger change only for checked inputs
    $('.product .new_variant_selection input:checked, .sticky_product_form .new_variant_selection input:checked')
        .trigger('change');
});

  // Variant Change Handler for Double/Triple Quantity Selectors & Price updates
  function updateVariantUI(selectClass) {
    $('.sticky_product_form, .product .product_variant_items').removeClass('two_select three_select one_select').addClass(selectClass);
     if($('.new-product-bundle-1').length > 0){
         $('.product_price_two').css('display', selectClass === 'two_select' ? 'block' : 'none');
         $('.product_price_three').css('display', selectClass === 'three_select' ? 'block' : 'none');
         $('.product_price_one').css('display', selectClass === 'one_select' ? 'block' : 'none');
    }
   
  }

  // Sync Double Variant Quantity Selection
  $('.product .two_variant_quantity select').change(function(){
    var dataVal = $(this).val();
    var doubleVal = $(this).find('option:selected').data('variantid');
    
    // Update ONLY the product-variant-double value in both forms
    $('.product .product-form form').find('input.product-variant-double').val(doubleVal);
    $('.sticky_product_form .product-form form').find('input.product-variant-double').val(doubleVal);
    $('.product .two_variant_quantity select').val(dataVal);
    $('.sticky_product_form .two_variant_quantity select').val(dataVal);
    
    // Update the image slider
    var dataImg = $(this).find('option:selected').data('slideimg');
    var dataImgIndex = $('.product__media-item-custom[data-mediaid="' + dataImg + '"]').data('slick-index');
    $('.product--main-slider .product__media-list-custom').slick('slickGoTo', dataImgIndex);
  });

  // Sync Triple Variant Quantity Selection
  $('.product .three_variant_quantity select').change(function(){
    var dataVal = $(this).val();
    var tripleVal = $(this).find('option:selected').data('variantid');
    
    // Update ONLY the product-variant-triple value in both forms
    $('.product .product-form form').find('input.product-variant-triple').val(tripleVal);
    $('.sticky_product_form .product-form form').find('input.product-variant-triple').val(tripleVal);
    $('.product .three_variant_quantity select').val(dataVal);
    $('.sticky_product_form .three_variant_quantity select').val(dataVal);
    
    // Update the image slider
    var dataImg = $(this).find('option:selected').data('slideimg');
    var dataImgIndex = $('.product__media-item-custom[data-mediaid="' + dataImg + '"]').data('slick-index');
    $('.product--main-slider .product__media-list-custom').slick('slickGoTo', dataImgIndex);
  });

  // Sync Double Variant Quantity in Sticky Form
  $('.sticky_product_form .two_variant_quantity select').change(function(){
    var dataVal = $(this).val();
    var doubleVal = $(this).find('option:selected').data('variantid');
    
    // Update ONLY the product-variant-double value in both forms
    $('.sticky_product_form .product-form form').find('input.product-variant-double').val(doubleVal);
    $('.product .product-form form').find('input.product-variant-double').val(doubleVal);
    $('.product .two_variant_quantity select').val(dataVal);
    $('.sticky_product_form .two_variant_quantity select').val(dataVal);
    
    // Update the image slider
    var dataImg = $(this).find('option:selected').data('slideimg');
    var dataImgIndex = $('.product__media-item-custom[data-mediaid="' + dataImg + '"]').data('slick-index');
    $('.product--main-slider .product__media-list-custom').slick('slickGoTo', dataImgIndex);
  });

  // Sync Triple Variant Quantity in Sticky Form
  $('.sticky_product_form .three_variant_quantity select').change(function(){
    var dataVal = $(this).val();
    var tripleVal = $(this).find('option:selected').data('variantid');
    
    // Update ONLY the product-variant-triple value in both forms
    $('.sticky_product_form .product-form form').find('input.product-variant-triple').val(tripleVal);
    $('.product .product-form form').find('input.product-variant-triple').val(tripleVal);
    $('.product .three_variant_quantity select').val(dataVal);
    $('.sticky_product_form .three_variant_quantity select').val(dataVal);
    
    // Update the image slider
    var dataImg = $(this).find('option:selected').data('slideimg');
    var dataImgIndex = $('.product__media-item-custom[data-mediaid="' + dataImg + '"]').data('slick-index');
    $('.product--main-slider .product__media-list-custom').slick('slickGoTo', dataImgIndex);
  });

  // Initialize Marquee with Slick Slider
  $('marquee-item').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 6,
    slidesToScroll: 1,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 0,
    responsive: [
      {
        breakpoint: 991, // Tablets
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 576, // Mobile devices
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  // Initialize Product Thumbnail Slider
  var thumbnailCount = $('.product-thumb-slider .thumbnail-list li').length;

  if (thumbnailCount > 6) {
    $('.product--main-slider .product__media-list-custom').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 200,
      asNavFor: '.product-thumb-slider .thumbnail-list'
    });
  } else {
    $('.product--main-slider .product__media-list-custom').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 200
    });
  }

  // Initialize Thumbnail Navigation Slider
  $('.product-thumb-slider .thumbnail-list').slick({
    slidesToShow: 6,
    infinite: false,
    asNavFor: '.product--main-slider .product__media-list-custom',
    centerMode: false,
    centerPadding: '0',
    arrows: true,
    speed: 500,
    cssEase: 'ease-in-out',
    swipeToSlide: true,
    touchThreshold: 10
  });

  // Thumbnail click handler to navigate to specific slide
  $('.product-thumb-slider .thumbnail-list__item').click(function(){
    var activeSlide = $(this).data('slick-index');
    $('.product--main-slider .product__media-list-custom').slick('slickGoTo', activeSlide);
  });

  // Toggle Extra Content for Button with extra content
  $('.button_with_extracontent .button_richtext').click(function(){
    $(this).siblings('.extra_content').slideToggle();
  });  
  
  //clear the cart when someone opens this product
  var targetProductUrl = 'https://getlanera.com/products/lanera-luxury-foundation';
  var currentUrl = window.location.href.split('?')[0];

  if (currentUrl === targetProductUrl) {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function () {
        console.log('Cart cleared successfully');
      },
      error: function (xhr, status, error) {
        console.error('Failed to clear cart:', error);
      }
    });
  }
  

 // ====== START: cart upsell product ==========
  // window.initUpsellSlider = function () {
  //   setTimeout(function () {
  //     $('.cart-upsell-product-list').slick({
  //       slidesToShow: 2.65,
  //       arrows: false,
  //       dots: false,
  //       infinite: false,
  //       prevArrow: `<button type="button" class="slick-prev" aria-label="Previous"><svg class="icon icon-arrow-prew" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  // <path d="M4.06667 -9.0518e-07L4.76995e-08 4C1.02014 5.00069 3.04658 6.99929 4.06667 8L4.57986 7.50347C3.66249 6.60347 2.44866 5.4048 1.37772 4.35342L7.99995 4.35342L7.99995 3.64716L1.37772 3.64716L4.57986 0.502097L4.06667 -9.0518e-07Z" fill="currentColor"></path>
  // </svg></button>`,
  //       nextArrow: `<button type="button" class="slick-next" aria-label="Next"><svg class="icon icon-arrow-next" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  // <path d="M3.93333 8L8 4C6.97986 2.99931 4.95342 1.00071 3.93333 -1.7776e-07L3.42014 0.496533C4.33751 1.39653 5.55134 2.5952 6.62228 3.64658L5.22927e-05 3.64658L5.22618e-05 4.35283L6.62228 4.35283L3.42014 7.4979L3.93333 8Z" fill="currentColor"></path></svg></button>`,
       
  //     });
  //   }, 100);
  // };
  // window.initUpsellSlider();

if($('.cart-upsell-section').hasClass('slider_loop')){
  var upsellLoop = true;
}
else{
  var upsellLoop = false;
}
window.initUpsellSlider = function () {
  setTimeout(function () {
    $('.cart-upsell-product-list').addClass('owl-carousel').owlCarousel({
      items: 2.6,
      loop: upsellLoop,
      dots: false,
      nav: false,

    });
  }, 100);
};
window.initUpsellSlider();





  
  // ====== END: cart upsell product ==========
  
  // ==== START: ajax cart functionality
  $(document).on("click", ".ajax-cart-button", function () {
    var productVaraintID = $(this).attr("data-variant-id");
      $('.drawer_loading').removeClass('hidden');
    addToCartJS(1, productVaraintID);
  });
  function addToCartJS(qty, productVaraintID) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": qty, "id": productVaraintID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
        setTimeout(() => {  
         $('.drawer_loading').addClass('hidden');
          }, 500);
      manageCartGifts()
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  } 
  // ==== END: ajax cart functionality

  let throttleTimeout = null;
    function observeCartDrawer() {
      const cartDrawer = document.querySelector("cart-drawer");
    
      if (cartDrawer) {
        const observer = new MutationObserver(function (mutations) {
          window.initUpsellSlider();
        });
    
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true
        });
      }
    }
    // Initialize observer
    observeCartDrawer();
  

});



function FreeProductsub() {
  $.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: "jsonp",
    success: function (data) {
      const items = data["items"];
      let hasSubscription = false;
      
      const freeProductVariantId = 51765246067058; // 🔁 Replace with your actual variant ID

      // Check if any product in the cart is a subscription
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.selling_plan_allocation) {
          hasSubscription = true;
          break;
        }else{
           $('.drawer_loading').addClass('hidden');
        }
      }

      if (hasSubscription) {
        // console.log("Subscription product found in cart.");
         $('.drawer_loading').addClass('hidden');
      } else {
        // console.log("No subscription product in cart. Checking to remove free product.");
        if(items.length == 0){
           $('.drawer_loading').addClass('hidden');
        }
        // Loop through cart to see if the free product is in the cart
        for (let i = 0; i < items.length; i++) {
          if (items[i].variant_id === freeProductVariantId) {
            removeFreeProduct(items[i].key);
            break; // Only remove once
          }
          else{
            $('.drawer_loading').addClass('hidden');
          }
        }
      }
    },
    error: function () {
      console.error("Failed to fetch cart contents.");
    }
  });
}

// 🧹 Function to remove item by its `key` (unique identifier in cart)
function removeFreeProduct(itemKey) {
  
  var cartDrawer = document.querySelector('cart-drawer');
  var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
  var sections_url = window.location.pathname;
  
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: itemKey,
      quantity: 0,
      sections: sectionsToRender,
      sections_url: sections_url
    },
    dataType: "json",
    success: function (response) {
     cartDrawer.renderContents(response);
        cartDrawer.open();
         if (response.item_count === 0) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        $('.drawer_loading').addClass('hidden');
    },
    error: function (xhr, status, error) {
      console.error("Error removing free product:", error);
    }
  });
}

 